import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import {
  createContext,
  FunctionComponent,
  ReactElement,
  // useContext,
  useMemo,
} from "react";
// import { GetUserProfileContext } from "../UserProfile";

export const MonitorOngoingBulkTransactionContext = createContext(null);

type Props = {
  children: ReactElement;
};

const MonitorOngoingBulkTransactionProvider: FunctionComponent<Props> = ({
  children,
}) => {
  // const { data: userData } = useContext(GetUserProfileContext);

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["ongoing_bulk_transactions"],
    // refetchInterval: 5 * 60 * 1000,
    staleTime: 0,
    // enabled: userData && userData?.organisation?.has_bulk_process_running,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`tm/transactions/upload/status`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
    }),
    [data, isLoading, isFetching],
  );
  return (
    <MonitorOngoingBulkTransactionContext.Provider value={contextValue}>
      {children}
    </MonitorOngoingBulkTransactionContext.Provider>
  );
};

export default MonitorOngoingBulkTransactionProvider;
